var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVilofarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 265.67 109.62",
    style: {
      enableBackground: "new 0 0 265.67 109.62"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#255088;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M244.61,22.79C261.94,15.4,264.5,4.46,265.67,0c-2.9,3.98-9.35,6.39-13.5,7.39 c-3.78,0.92-11.1,1.93-18.09,5.3c-6.95,3.35-9.73,9.03-11.77,13.37c-2.24,4.77-3.49,12.29-3.49,12.29 C226.91,28.98,232.22,28.08,244.61,22.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236.7,30.52c-17.33,7.39-19.9,18.34-21.06,22.8c2.9-3.99,9.35-6.39,13.5-7.4c3.78-0.92,11.1-1.93,18.09-5.3 c6.95-3.34,9.73-9.03,11.77-13.37c2.24-4.77,3.49-12.3,3.49-12.3C254.4,24.34,249.1,25.23,236.7,30.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.7,73.32c0.24,2.16,0.42,4.44,0.48,7.2h0.12c0.96-2.52,1.56-4.08,3.36-7.8l9.66-19.68h11.46L22.2,93.54 H9.36L5.04,61.32c-1.38-0.24-3.3-0.48-5.04-0.6l1.32-7.14c4.38-0.48,9.12-0.66,14.1-0.54L17.7,73.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.04,93.54H39.3l4.14-21.48v-0.12c-1.38-0.24-3.3-0.48-5.04-0.6l1.32-7.14c4.98-0.54,10.32-0.72,16.02-0.54 L50.04,93.54z M51.54,61.44c-3.66,0-6.12-2.82-6.12-5.88c0-3.9,3.36-6.72,6.96-6.72c3.6,0,6.12,2.82,6.12,5.76 C58.5,58.62,55.14,61.44,51.54,61.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.72,93.54H58.98l6.78-35.58c-1.38-0.24-3.3-0.48-5.04-0.6l1.32-7.14c4.98-0.54,10.32-0.72,16.02-0.54 L69.72,93.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.34,94.26c-9.54,0-12.66-4.26-12.66-10.86c0-13.32,9.54-20.4,18.9-20.4c9.42,0,12.54,4.74,12.54,11.1 C108.12,86.28,99.18,94.26,89.34,94.26z M93.9,72.48c-4.14,0-6,5.64-6,9.3c0,1.56,0.6,2.94,2.7,2.94c4.5,0,6.24-5.46,6.24-9.18 C96.84,73.5,96.12,72.48,93.9,72.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.28,58.38c-0.78-0.24-1.86-0.42-2.64-0.42c-2.28,0-3.06,0.78-3.66,3.9l-0.36,1.86h4.92l-1.62,8.4h-4.98 l-4.08,21.84c-1.74,9.36-6.9,13.98-14.58,13.98c-1.68,0-3.6-0.18-5.28-0.54l2.46-8.88c0.66,0.18,1.74,0.36,2.52,0.36 c2.04,0,3.3-0.72,4.14-5.16l4.08-21.6h-3.72l1.68-8.4h3.72l0.42-2.4c1.32-7.68,5.22-12.24,14.64-12.24c1.56,0,3.24,0.12,4.68,0.48 L134.28,58.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.38,93.54c0,0-1.74,0.12-6.6,0.12c-1.26,0-2.52,0-3.78-0.06c0.48-2.04,0.9-3.66,1.74-5.7h-0.12 c-2.82,4.2-6.36,6.42-10.5,6.42c-4.92,0-7.5-3.18-7.5-9.72c0-11.64,6.6-21.6,19.74-21.6c3.9,0,8.22,0.24,12.36,1.02 C159,83.22,157.38,93.54,157.38,93.54z M148.44,71.58c-4.08,0-6.72,6.36-6.72,10.92c0,1.56,0.24,2.34,1.14,2.34 c2.28,0,6.42-6.72,7.38-11.7l0.24-1.26C149.88,71.7,149.28,71.58,148.44,71.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.62,73.62c-4.02-1.5-8.04,2.16-10.26,13.86l-1.14,6.06h-10.74l4.14-21.42v-0.18 c-1.38-0.24-3.36-0.48-5.04-0.6l1.32-7.14c4.98-0.54,10.26-0.72,15.3-0.54c-0.36,1.92-0.9,3.84-1.8,6.12h0.12 c2.88-5.04,5.94-7.62,10.5-6.66L187.62,73.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.56,93.54h-10.74l3.48-18.18c0.42-2.22,0.18-2.94-0.6-2.94c-1.86,0-6.18,6-7.38,12.24l-1.68,8.88h-10.68 l3.48-18.18c0.42-2.22,0.18-2.94-0.6-2.94c-1.86,0-6.18,6-7.38,12.24l-1.68,8.88h-10.74l4.08-21.36l0.06-0.24 c-1.38-0.24-3.36-0.48-5.04-0.6l1.32-7.14c4.98-0.54,10.38-0.72,15.42-0.54c-0.3,1.62-0.9,3.72-1.8,5.7h0.12 c2.7-3.84,5.82-6.42,10.68-6.42c3.36,0,6.18,1.74,6.18,5.88c0,0.18,0,0.48-0.06,0.9h0.06c2.76-4.26,6-6.78,10.86-6.78 c6.12,0,7.68,4.38,6.66,9.66L235.56,93.54z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVilofarm);
export default __webpack_public_path__ + "static/media/Vilofarm.052c567d89b4cbe52facd19cdef51f3c.svg";
export { ForwardRef as ReactComponent };